import React, {useEffect} from 'react';
import {HashRouter, Navigate, Route, Routes} from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ReportsPage from './pages/ReportsPage';
import ReportEditorPage from './pages/ReportEditorPage';
import {requestPersistentStorage} from './data/reportStore';
import './App.css';
import './brand.css';

function App() {
  useEffect(() => {
    requestPersistentStorage();
  }, []);

  return (
    <HashRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="/new" element={<ReportEditorPage />} />
          <Route path="/report/:id" element={<ReportEditorPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;